export const productionLikeEnvironments = ['production', 'staging', 'strabag']

export const isProductionLikeEnvironment = productionLikeEnvironments.includes(
  import.meta.env.VITE_TARGET_ENV
)
